export function isSupabaseUserNotFoundError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;

  const err = error as Record<string, unknown>;
  const code = typeof err.code === "string" ? err.code : null;
  if (code === "user_not_found") return true;

  const status = typeof err.status === "number" ? err.status : null;
  const message = typeof err.message === "string" ? err.message : "";

  return status === 403 && message.toLowerCase().includes("user");
}
